import { ChevronDown, MapPin } from "lucide-react";
import { useI18n } from "../lib/i18n";

const HERO_BG =
  "https://customer-assets.emergentagent.com/job_1201f7ae-ca7d-4571-b978-7b9b5b19105a/artifacts/9zp2qw3o_IMG_3233.jpeg";

const scrollTo = (id) => {
  const el = document.getElementById(id);
  if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
};

export const Hero = () => {
  const { t } = useI18n();

  return (
    <section
      id="home"
      data-testid="hero-section"
      className="relative min-h-screen w-full overflow-hidden"
    >
      <div
        className="absolute inset-0 bg-cover bg-center scale-105"
        style={{ backgroundImage: `url(${HERO_BG})` }}
        aria-hidden
      />
      <div
        className="absolute inset-0"
        style={{
          background:
            "linear-gradient(180deg, rgba(15,23,15,0.55) 0%, rgba(15,23,15,0.25) 35%, rgba(15,23,15,0.55) 100%)",
        }}
        aria-hidden
      />

      <div className="relative z-10 max-w-7xl mx-auto px-5 md:px-10 min-h-screen flex flex-col justify-end pb-20 md:pb-28 pt-32">
        <div className="max-w-3xl">
          <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-white/10 backdrop-blur-md border border-white/20 text-white/95 text-xs md:text-sm font-semibold tracking-[0.18em]">
            <MapPin className="w-3.5 h-3.5 text-[#FFB800]" />
            <span data-testid="hero-overline">{t.hero.overline}</span>
          </div>

          <h1
            data-testid="hero-title"
            className="mt-6 text-white font-black tracking-tight leading-[0.95] text-[15vw] sm:text-7xl lg:text-[7.5rem]"
            style={{ fontFamily: "'Outfit', system-ui, sans-serif" }}
          >
            R&V VILLA
          </h1>

          <p
            data-testid="hero-subtitle"
            className="mt-6 text-white/90 text-base sm:text-lg lg:text-xl leading-relaxed max-w-2xl"
            style={{ fontFamily: "'Manrope', system-ui, sans-serif" }}
          >
            {t.hero.subtitle}
          </p>

          <div className="mt-10 flex flex-wrap items-center gap-4">
            <button
              data-testid="hero-cta-book"
              onClick={() => scrollTo("contact")}
              className="group inline-flex items-center gap-2 bg-[#FFB800] hover:bg-[#FFC933] text-[#1A1A1A] font-semibold rounded-full px-7 md:px-8 py-4 transition-all duration-300 hover:-translate-y-0.5 shadow-[0_10px_30px_-10px_rgba(255,184,0,0.6)]"
            >
              {t.hero.cta}
              <span className="w-1.5 h-1.5 rounded-full bg-[#1A1A1A] group-hover:translate-x-1 transition-transform" />
            </button>
            <button
              data-testid="hero-cta-scroll"
              onClick={() => scrollTo("about")}
              className="inline-flex items-center gap-2 text-white hover:text-[#FFB800] font-medium transition-colors"
            >
              <span>{t.hero.scroll}</span>
              <ChevronDown className="w-4 h-4 animate-bounce" />
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
